import { useState, useEffect } from 'react'
import './Crossfader.css'

function Crossfader({ deckARef, deckBRef }) {
  const [fadePosition, setFadePosition] = useState(50) // 0 = full A, 50 = center, 100 = full B

  useEffect(() => {
    // Get gain nodes from both decks
    const gainA = deckARef.current?.getGainNode?.()
    const gainB = deckBRef.current?.getGainNode?.()

    if (!gainA || !gainB) return

    // Convert fade position (0-100) to normalized value (0-1)
    const normalized = fadePosition / 100

    // Equal power crossfade curves (intersect at -3dB for smooth transition)
    // Using cosine curves for equal power: gain = cos(position * π/2)
    const gainAValue = Math.cos(normalized * 0.5 * Math.PI) // Full at 0%, silent at 100%
    const gainBValue = Math.cos((1.0 - normalized) * 0.5 * Math.PI) // Silent at 0%, full at 100%

    // Apply gains
    gainA.gain.value = gainAValue
    gainB.gain.value = gainBValue

    console.log(`[CROSSFADER] Position: ${fadePosition}% | Deck A: ${(gainAValue * 100).toFixed(0)}% | Deck B: ${(gainBValue * 100).toFixed(0)}%`)
  }, [fadePosition, deckARef, deckBRef])

  const handleFaderChange = (e) => {
    setFadePosition(parseInt(e.target.value))
  }

  const handleCenterClick = () => {
    setFadePosition(50) // Reset to center
  }

  const getLabel = () => {
    if (fadePosition === 0) return 'A ONLY'
    if (fadePosition === 100) return 'B ONLY'
    if (fadePosition === 50) return 'CENTER'
    if (fadePosition < 50) return `A +${50 - fadePosition}%`
    return `B +${fadePosition - 50}%`
  }

  return (
    <div className="crossfader">
      <div className="crossfader-header">
        <h5>CROSSFADER</h5>
        <span className="crossfader-label">{getLabel()}</span>
      </div>

      <div className="crossfader-control">
        <span className="deck-indicator deck-a-indicator">A</span>

        <input
          type="range"
          min="0"
          max="100"
          value={fadePosition}
          onChange={handleFaderChange}
          className="crossfader-slider"
        />

        <span className="deck-indicator deck-b-indicator">B</span>
      </div>

      <div className="crossfader-marks">
        <span>A</span>
        <button
          className="center-btn"
          onClick={handleCenterClick}
          title="Reset to center"
        >
          CENTER
        </button>
        <span>B</span>
      </div>

      <div className="crossfader-info">
        <small>Equal power crossfade (-3dB at center)</small>
      </div>
    </div>
  )
}

export default Crossfader
